import React from "react";
import { loaders } from "../../assets/images/loading";

interface IProps {
  race: string;
}

const InnerLoader = ({ race }: IProps) => (
  <div style={{
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: 990
  }}>
    <img
      src={loaders[race]}
      alt={"loader"}
      style={{
        display: "flex",
        marginLeft: "auto",
        marginRight: "auto",
        top: "100vh",
        zIndex: 999
      }}
    />
  </div>);

export default InnerLoader;
